import React, { useEffect, useState } from 'react';
import { ref, onValue, DataSnapshot } from 'firebase/database';
import { auth, database } from '../api/firebase';
import { IUser, IUsers } from '../types/room';
import useRoomcode from '../hooks/useRoomcode';
import BubbleText from './BubbleText';

interface FlatUser extends IUser {
  uid: string;
};

interface UsersListProps { }

const UsersList: React.FC<UsersListProps> = () => {
  const [users, setUsers] = useState<IUsers>({});
  const roomcode = useRoomcode();

  useEffect(
    () => {
      const usersRef = ref(database, `bubbles/${roomcode}/users`);
      const unsubscribe = onValue(usersRef, (snapshot: DataSnapshot) => {
        setUsers(snapshot.exists() ? snapshot.val() : {});
      });
      return unsubscribe;
    },
    [roomcode]
  );

  const usersArray: FlatUser[] = [];
  for (const [uid, user] of Object.entries(users)) {
    const flatUser: FlatUser = { ...user, uid };
    usersArray.push(flatUser)
  }

  return (
    <>
      <p className='font-mono'>who's here:</p>
      <div className="overflow-y-auto overflow-x-hidden max-h-screen-1/5">
        {usersArray.map(user => (
          <BubbleText
            key={user.uid}
            text={`${user.nickname} ${user.uid === auth.currentUser!.uid ? '(you)' : ''}`}
          />
        ))}
      </div>
    </>
  );
}

export default UsersList;
